// copied and edited from packages/ui/src/components/FlavorFinder/components/Header/FlavorFinderHeader.tsx
import type { FC, PropsWithChildren } from "react";

import dompurify from "isomorphic-dompurify";

import styles from "./FlavorFinderHeader.module.scss";

export type FlavorFinderHeaderProps = {
  title?: string;
  subtitle?: string;
  infoText?: string;
};

const { sanitize } = dompurify;

export const FlavorFinderHeader: FC<PropsWithChildren<FlavorFinderHeaderProps>> = ({
  title,
  subtitle,
  children,
  infoText,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        {infoText && <div dangerouslySetInnerHTML={{ __html: sanitize(infoText) }} className={styles.info}></div>}
        {title && <h1 dangerouslySetInnerHTML={{ __html: sanitize(title) }} className={styles.title}></h1>}
        {subtitle && <p dangerouslySetInnerHTML={{ __html: sanitize(subtitle) }} className={styles.subtitle}></p>}
      </div>
      {children}
    </div>
  );
};
